// Componente per sistema ExeDialog DDT2026 - Step destinazione (trasporto NON a carico nostro)
// Autocomplete che chiama verificaDdt ad ogni carattere digitato
import React, { useState, useRef, useEffect } from 'react';
import { AutoComplete } from 'primereact/autocomplete';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ValoriVerificati } from './ValoriVerificati';

export function Destinazione(props) {
    const { currURLSearchParams, onFinish, verificaData, verificaDdt, buildInputFromSearchParams } = props;
    const inputRef = useRef();
    
    const [state, setState] = useState({
        destinazione: currURLSearchParams.get('destinazione') || '',
        id_dest: currURLSearchParams.get('id_dest') ? parseInt(currURLSearchParams.get('id_dest'), 10) : null
    });
    const [suggestions, setSuggestions] = useState([]);
    const [searching, setSearching] = useState(false);

    // righe_suggerimento dalla risposta iniziale
    const suggerimenti = verificaData?.righe_suggerimento || [];

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, [verificaData]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (state.destinazione) {
            onFinish({
                destinazione: state.destinazione,
                id_dest: state.id_dest
            });
        }
    };

    const handleRowSelect = (e) => {
        const row = e.data;
        onFinish({
            destinazione: row.destinazione,
            id_dest: row.id_dest
        });
    };

    // Chiama verificaDdt ad ogni carattere digitato
    const searchOptions = async (event) => {
        const query = event.query;
        if (!query || query.length < 1) {
            setSuggestions([]);
            return;
        }

        setSearching(true);
        try {
            const currentInput = buildInputFromSearchParams(currURLSearchParams);
            const input = {
                ...currentInput,
                destinazione: query
            };
            
            const result = await verificaDdt(input);
            // Se il campo è stato verificato (campo_da_verificare è passato al successivo),
            // mostra il valore verificato come unica opzione confermabile
            if (result?.campo_da_verificare !== 'destinazione') {
                const v = result?.valori_verificati;
                setSuggestions(v?.id_dest ? [{ destinazione: v.destinazione, id_dest: v.id_dest }] : []);
            } else {
                setSuggestions(result?.opzioni_selezione || []);
            }
        } catch (err) {
            console.error('Errore ricerca:', err);
            setSuggestions([]);
        } finally {
            setSearching(false);
        }
    };

    const itemTemplate = (item) => (
        <span>{item.destinazione} <span style={{fontSize: 'x-small', color: '#666'}}>({item.id_dest})</span></span>
    );

    return (
        <div className="card-body">
            <h5 className="card-title">Destinazione</h5>
            <p className="text-muted">Digita per cercare o seleziona dalla tabella.</p>
            
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label htmlFor="destinazione" className="form-label">Destinazione</label>
                    <AutoComplete 
                        ref={inputRef}
                        id="destinazione"
                        value={state.destinazione}
                        suggestions={suggestions}
                        completeMethod={searchOptions}
                        field="destinazione"
                        onChange={(e) => {
                            const value = typeof e.value === 'object' ? e.value.destinazione : e.value;
                            const selected = suggestions.find(o => o.destinazione === value);
                            setState({
                                destinazione: value,
                                id_dest: selected?.id_dest || state.id_dest
                            });
                        }}
                        onSelect={(e) => onFinish({
                            destinazione: e.value.destinazione,
                            id_dest: e.value.id_dest
                        })}
                        itemTemplate={itemTemplate}
                        className="w-100"
                        inputClassName="w-100"
                        minLength={1}
                        delay={300}
                    />
                    {searching && <small className="text-muted">Ricerca in corso...</small>}
                </div>

                {suggerimenti.length > 0 && (
                    <div className="card mb-3">
                        <DataTable 
                            value={suggerimenti} 
                            selectionMode="single" 
                            onRowSelect={handleRowSelect}
                            size="small"
                            scrollable
                            scrollHeight="400px"
                            header="Destinazioni frequenti"
                        >
                            <Column field="destinazione" header="Destinazione" sortable />
                        </DataTable>
                    </div>
                )}

                <button className="btn btn-primary" disabled={!state.destinazione}>
                    Prosegui
                </button>
            </form>
            
            <ValoriVerificati valori={verificaData?.valori_verificati} />
        </div>
    );
}

Destinazione.displayName = 'destinazione';
